import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import PositionedSnackbar from "../snackbar";
import axios from "axios";
import { UseHrApp } from "../../utils/context";

export default function LeavesModal(props) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",

    p: 4,
  };

  const { token, setshow, settext, setseverity, show, text, severity } =
    UseHrApp();
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  async function ManageLeaveAccept() {
    try {
      const res = await axios({
        url: "https://hr-app-api.onrender.com/leave/manage",
        method: "PATCH",
        data: {
          id: props.id,
          approved: true,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (res?.data?.status) {
        setshow(true);
        settext("Leave Reviewed");
        setseverity("success");
        handleClose();
      }
    } catch (error) {
      setshow(true);
      settext("Leave Review Failed");
      setseverity("error");
    }
  }

  async function ManageLeaveDecline() {
    try {
      const res = await axios({
        url: "https://hr-app-api.onrender.com/leave/manage",
        method: "PATCH",
        data: {
          id: props.id,
          approved: false,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (res?.data?.status) {
        setshow(true);
        settext("Leave Reviewed");
        setseverity("success");
      }
    } catch (error) {
      setshow(true);
      settext("Leave Review Failed");
      setseverity("error");
    }
  }

  return (
    <div>
      <Button
        onClick={handleOpen}
        className="w-[100px] flex justify-center items-center text-2xl font-semibold"
      >
        ...{" "}
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className=" flex flex-col gap-2">
            <p className=" font-[Archivo] lg:text-xl font-semibold">
              Leave Details
            </p>
            <PositionedSnackbar
              value={show}
              setshow={setshow}
              text={text}
              severity={severity}
            />

            <div>
              <p>
                Name: {props.employee.firstname} {props.employee.lastname}
              </p>

              <p>
                Start Date:{" "}
                {new Date(props.startDate).toISOString().slice(0, 10)}
              </p>

              <p>
                End Date: {new Date(props.endDate).toISOString().slice(0, 10)}
              </p>
              <p>Duration: {props.duration}</p>
              <p>Reason: {props.reason}</p>
              <p>Leave Type: {props.leaveType}</p>

              {!props.reviewed && (
                <div className=" flex gap-3 mt-[1em] ">
                  <button
                    className=" w-full p-2 bg-[#BDF3C0] flex justify-center items-center"
                    onClick={ManageLeaveAccept}
                  >
                    Accept
                  </button>
                  <button
                    className=" w-full p-2 bg-[#F9C0C0]  flex justify-center items-center"
                    onClick={ManageLeaveDecline}
                  >
                    Decline
                  </button>
                </div>
              )}
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
}
